import UserMobile from "@/styles/UserMobile";
import { AreaEnum, User } from "@/types/user";
import { Form, Input, Modal, notification } from "antd";
import { FC, useState } from "react";
import { useTranslation } from 'react-i18next';
import useUserAdd from "../hooks/useUserAdd";
import AvatarUpload from "@/styles/AvatarUpload";

interface IAddUser {
  openStatus: boolean;
  orgId?: string;
  onOk: (user: User) => void;
  onCancel: () => void;
}

type UserAddFieldType = {
  name1?: string;
  name2?: string;
  mobile?: string;
  areaCode?: AreaEnum;
  avatar?: string;
  permission?: boolean;
};

export const AddUser: FC<IAddUser> = ({ openStatus, onOk, onCancel }) => {
  const { t } = useTranslation();
  const [name1, setName1] = useState<string>("");
  const [name2, setName2] = useState<string>("");
  const [areaCode, setAreaCode] = useState<AreaEnum>(AreaEnum.CN);
  const [mobile, setMobile] = useState<string>("");
  const [avatar, setAvatar] = useState<string>("");
  const [loading, { addUser }] = useUserAdd();
  const [inForm] = Form.useForm();

  const onFinish = () => {
    inForm.validateFields().then(() => {
      if(!mobile) {
        notification.warning({ placement: 'top', message: t('member.phNumberTip')});
        return
      }
      addUser({ name1, name2, areaCode, mobile, avatar })
        .then(user => {
          resetFormValue();
          notification.success({ placement: 'top', message: t('member.addSuccess')})
          onOk(user);
          onCancel();
        })
    }).catch(() => {})
  }

  const handleCancel = () => {
    setAreaCode(AreaEnum.CN)
    onCancel()
    resetFormValue()
  }

  const resetFormValue = () => {
    setTimeout(() => {
      inForm.resetFields()
      setMobile("");
      setAvatar("");
      setName1("");
      setName2("");
      setAreaCode(AreaEnum.CN);
    }, 500);
  }

  return (
    <Modal
      title={t('member.addMember')}
      open={openStatus}
      confirmLoading={loading}
      onOk={() => onFinish()}
      onCancel={handleCancel}
      maskClosable={false}
      destroyOnClose
    >
      <Form form={inForm} style={{ marginTop: 16 }} name="user" autoComplete="off">
        <Form.Item<UserAddFieldType> label={t('member.avatar')} name="avatar">
          <AvatarUpload uniChar={null} avatarId={avatar} onChange={setAvatar} />
        </Form.Item>
        <Form.Item<UserAddFieldType> label="Name1" name="name1" rules={[ { max: 100, message: t('member.maxLengthTip') } ]}>
          <Input value={name1} onChange={e => setName1(e.target.value)} count={{ show:true, max: 100 }} placeholder={t('login.enterAcnt')} />
        </Form.Item>

        <Form.Item<UserAddFieldType> label="Name2" name="name2" rules={[ { max: 100, message: t('member.maxLengthTip') } ]}>
          <Input value={name2} onChange={e => setName2(e.target.value)} count={{ show:true, max: 100 }} placeholder={t('login.enterAcnt')} />
        </Form.Item>
        <Form.Item<UserAddFieldType> label={t('member.phNumber')} name="mobile" required>
          <UserMobile
            areaCode={areaCode}
            setAreaCode={setAreaCode}
            mobile={mobile}
            setMobile={setMobile}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
